module.exports = {"513337100":"金珠镇","513337101":"香格里拉镇","513337102":"桑堆镇","513337103":"吉呷镇","513337104":"噶通镇","513337201":"省母乡","513337204":"巨龙乡","513337205":"邓坡乡","513337206":"木拉乡","513337207":"赤土乡","513337209":"蒙自乡","513337210":"各卡乡","513337212":"俄牙同乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513337.json
// module id = 2559
// module chunks = 0